webpackJsonp([213720915766396],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _sectionHeading = __webpack_require__(44);
	
	var _sectionHeading2 = _interopRequireDefault(_sectionHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectItem = function ProjectItem(_ref) {
	  var customClassName = _ref.customClassName,
	      name = _ref.name,
	      title = _ref.title,
	      realURL = _ref.realURL,
	      desc = _ref.desc,
	      path = _ref.path,
	      url = _ref.url;
	  return _react2.default.createElement(
	    "div",
	    { id: path, className: "project-item " + customClassName },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "project-item-content" },
	        _react2.default.createElement(
	          "h4",
	          null,
	          name
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          desc
	        ),
	        url ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: url },
	          _react2.default.createElement(
	            "div",
	            { className: "button-purple" },
	            "Read More"
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "project-item-icon" },
	        _react2.default.createElement(
	          "a",
	          { href: realURL, target: "_blank" },
	          _react2.default.createElement("img", { src: "/static/" + path + ".png" })
	        )
	      )
	    )
	  );
	};
	
	var HomepageProjects = function HomepageProjects(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "homepage-projects" },
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(_sectionHeading2.default, {
	        title: "Manifesting Genius Through Innovative Strategies",
	        description: "Housing a great amount of international businesses allowed us to generate a high number of projects that speak volumes and transform markets. We break the boarders of comfort zone by tempting the levels of probability. We believe that growth is only a result of well calculated risk. Fueled by the urge for expansion and progress, we create products which are beneficial for developers, clients and business people in general. Here are some of our projects and we are not stopping there.",
	        small: true
	      })
	    ),
	    props.projects.map(function (project, idx) {
	      var css = idx % 2 === 0 ? "default-project" : "alternate-project";
	      return _react2.default.createElement(ProjectItem, _extends({ customClassName: css }, project));
	    })
	  );
	};
	
	exports.default = HomepageProjects;
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeading = function SectionHeading(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      small = _ref.small;
	  return _react2.default.createElement(
	    "div",
	    { className: "section-heading" },
	    _react2.default.createElement(
	      "h2",
	      { className: small ? "small-heading" : "" },
	      title
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      description
	    )
	  );
	};
	
	exports.default = SectionHeading;
	module.exports = exports["default"];

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var SERVICES = exports.SERVICES = [{
	  name: "Artificial Intelligence",
	  desc: "Delving on the potential of AI and its practical use in our day-to-day operations.",
	  icon: "ai-icon"
	}, {
	  name: "Big Data",
	  desc: "Cooperating and managing cloud-based services with scalable data storage and analytics.",
	  icon: "big-data-icon"
	}, {
	  name: "Real-Time Bidding",
	  desc: "Working closely with RTB hosts who track, measure, analyze and gather real-time results.",
	  icon: "rtb-icon"
	}, {
	  name: "Computer Reservation System",
	  desc: "CRS platforms storing and retrieving info related to travel, vehicle rentals, and the like.",
	  icon: "reservation-icon"
	}, {
	  name: "SFM",
	  desc: "Protect your customers and reduce losses from fraud payments.",
	  icon: "sfm-icon"
	}, {
	  name: "Game Development",
	  desc: "Creating gaming environments that transcend real life experiences, while providing users with new dimensions of fun.",
	  icon: "game-dev-icon"
	}, {
	  name: "Affiliate Marketing",
	  desc: "Performance-based ad networks that award affiliates for bringing visitors to different sites, and vice versa.",
	  icon: "marketing-icon"
	}, {
	  name: "Software Development",
	  desc: "Engineering various projects such as software and applications that bring value to users.",
	  icon: "software-icon"
	}];
	
	var PROJECTS = exports.PROJECTS = [{
	  name: "Adwe.com",
	  title: "RTB Platform",
	  desc: "Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. Minute after minute, inventory is being bought and sold through auctions, thus allowing both parties (advertisers and publishers) to seamlessly generate revenue.",
	  path: "adwe",
	  url: "/project/adwe",
	  realURL: "https://adwe.com"
	}, {
	  name: "Abago.com",
	  title: "Flight Search - OTA",
	  desc: "Harboring one of the biggest databases of flights all over the world to help people find, compare, and book economical air fares. The systems we integrate take care of rapid search conduct that automatically serves users with the right and most prominent option for their wished travel dates.",
	  path: "abago",
	  url: "/project/abago",
	  realURL: "https://abago.com"
	  /*
	  {
	    title: "Mobile Development",
	    desc: "Utilizing our in-house 3D engine for Android and iOS platforms which allows developers to easily create 2D and 3D mobile applications in native Android and iOS platforms. Through continuous upgrades and updates, we make sure that only educational and informational apps are being created for our users.",
	    path: "mobile-device",
	  }
	  */
	}];
	
	var MANAGMENT = exports.MANAGMENT = [];
	
	var ADMINISTRATION = exports.ADMINISTRATION = [];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _data = __webpack_require__(23);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _heroSmall = __webpack_require__(43);
	
	var _heroSmall2 = _interopRequireDefault(_heroSmall);
	
	var _homepageProjects = __webpack_require__(78);
	
	var _homepageProjects2 = _interopRequireDefault(_homepageProjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_heroSmall2.default, {
	      title: "Projects Worth Living For",
	      desc: "Our projects are a result of joined forces from various fields combined with creativity, precision, and dedication."
	    }),
	    _react2.default.createElement(_homepageProjects2.default, { projects: _data.PROJECTS })
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-323ccd7dccb51e7743c2.js